import React, { useContext } from 'react';
import tw from 'twin.macro';
import { Link } from 'react-router-dom';
import { PreferenceContext } from '../context';
import { gaEvent } from 'services/ga';
import { Small } from '../text';

export const Tag = ({ label, favorite, blocked, user, ...restProps }) => {
  const {
    preference: { theme },
  } = useContext(PreferenceContext);
  const isLightTheme = theme === 'light';
  const labelValue = label.toLowerCase();

  return (
    <div
      css={[
        tw`bg-secondary inline-flex items-center mb-3 mr-3 rounded-lg transition-all hover:opacity-75 hover:scale-110 active:scale-95`,
        isLightTheme && tw`bg-input-back`,
      ]}
      {...restProps}
    >
      <Small>
        <Link
          to={`/tag/${encodeURIComponent(label)}`}
          css={[tw`py-1 px-2`]}
          onClick={() => gaEvent('dmp_tag_click', labelValue)}
        >
          {labelValue}
        </Link>
      </Small>
    </div>
  );
};
